import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { airesMappingStatusQuery } from '@/query';
import { TutorialMappingCounts } from '@/types';

export const useTutorialMappingCounts = (enabled: boolean): TutorialMappingCounts => {
  const { data } = useQuery({ ...airesMappingStatusQuery(), enabled });

  return useMemo(
    () => ({
      counts: {
        loans: data?.result?.loanCodesUnmappedCount ?? 0,
        shares: data?.result?.shareCodesUnmappedCount ?? 0,
        pfc: data?.result?.pfcCodesUnmappedCount ?? 0,
      },
      totals: {
        loans: data?.result?.loanCodesTotalCount ?? 0,
        shares: data?.result?.shareCodesTotalCount ?? 0,
        pfc: data?.result?.pfcCodesTotalCount ?? 0,
      },
    }),
    [data],
  );
};
